<template>
  <div>
    <!---支付单信息----->
    <div class="card">
      <div class="section">
        <div class="section-title">
          <base-section-title title="支付单信息" />
        </div>
        <div class="section-content">
          <jczh-descriptions
            :info="feePayInfo"
            :option="feeOptions"
            :el-attrs="{
              size: 'medium',
              column: 2,
              labelStyle: {
                whiteSpace: 'nowrap'
              }
            }"
          />
        </div>
      </div>
    </div>

    <!----项目信息------->

    <div class="card">
      <div class="section">
        <div class="section-title">
          <base-section-title title="项目信息" />
        </div>
        <div class="section-content">
          <jczh-table-content :data="projectList" :option="projectOptions" />
        </div>
      </div>
    </div>

    <!----专家费用----->

    <div class="card">
      <div class="section">
        <div class="section-title">
          <base-section-title title="专家费用" />
        </div>
        <div class="section-content">
          <jczh-table-content :data="expertList" :option="expertOptions">
            <template v-slot:authStatus="{ row }">
              <status-tag
                v-if="expertAuthStatusDict.translate(row.authStatus)"
                :type="expertAuthStatusDict.translate(row.authStatus).type"
                :label="expertAuthStatusDict.translate(row.authStatus).label"
                size="small"
              />
              <span v-else> - </span>
            </template>

            <template v-slot:taskStatus="{ row }">
              <status-tag
                v-if="expertTaskStatusDict.translate(row.taskStatus)"
                :type="expertTaskStatusDict.translate(row.taskStatus).type"
                :label="expertTaskStatusDict.translate(row.taskStatus).label"
                size="small"
              />
              <span v-else> - </span>
            </template>

            <template v-slot:payStatus="{ row }">
              <status-tag
                v-if="expertFeePayStatusDict.translate(row.payStatus)"
                :type="expertFeePayStatusDict.translate(row.payStatus).type"
                :label="expertFeePayStatusDict.translate(row.payStatus).label"
                size="small"
              />
              <span v-else> - </span>
            </template>

            <template v-if="showPay" v-slot:last>
              <el-table-column label="操作" width="180px" align="center">
                <template slot-scope="{ row }">
                  <el-button type="text" @click="openDetail(row)">
                    查看详情
                  </el-button>
                  <el-button
                    v-if="
                      row.payStatus !== expertFeePayStatusDict.SUCCESS.value &&
                        row.authStatus === expertAuthStatusDict.YES.value &&
                        row.taskStatus === expertTaskStatusDict.NO.value
                    "
                    type="text"
                    @click="openPay(row)"
                  >
                    发起打款
                  </el-button>
                </template>
              </el-table-column>
            </template>
          </jczh-table-content>
          <div class="p-t-20 text-bold">
            合计金额：<span
              class="text-danger"
            >{{ strToThousands(totalExpertFee) }}元</span>
          </div>
        </div>
      </div>
    </div>

    <!----专家费用详情弹窗---->
    <el-dialog
      title="查看详情"
      :visible.sync="detailVisible"
      width="400px"
      :modal-append-to-body="false"
      :close-on-click-modal="false"
      :append-to-body="true"
      class="dialog"
    >
      <div>
        <jczh-descriptions
          :info="expertFeeInfo"
          :option="detailOptions"
          :el-attrs="{
            size: 'medium',
            column: 1,
            labelStyle: {
              whiteSpace: 'nowrap'
            }
          }"
        />
      </div>
    </el-dialog>
  </div>
</template>
<script>
import BaseSectionTitle from '@/components/common/BaseSectionTitle'
import StatusTag from '@/components/common/StatusTag.vue'

import { getExpertFeeOrderDetailApi, submitExpertFeePayApi } from '@/api/expert'

import { strToThousands } from '@/utils/utils'

import {
  extractFeeAuditDict,
  expertAuthStatusDict,
  expertFeePayStatusDict,
  expertTaskStatusDict
} from '@/dictionary/expert'

export default {
  components: {
    BaseSectionTitle,
    StatusTag
  },

  props: {
    isByOrderId: {
      type: Boolean,
      default: true
    },

    showPay: {
      type: Boolean,
      default: false
    },

    requestQuery: {
      type: Object,
      default: () => {}
    }
  },

  data() {
    return {
      extractFeeAuditDict,
      expertAuthStatusDict,
      expertFeePayStatusDict,
      expertTaskStatusDict,

      detailVisible: false,
      feePayInfo: {},
      feeOptions: [
        {
          label: '支付单名称',
          prop: 'orderName'
        },
        {
          label: '支付单编号',
          prop: 'orderCode'
        }
      ],

      projectList: [],
      projectOptions: [
        {
          label: '项目名称',
          prop: 'orderName'
        },
        {
          label: '项目编号',
          prop: 'orderCode'
        }
      ],

      expertList: [],
      expertFeeInfo: {}
    }
  },

  computed: {
    expertOptions() {
      return [
        {
          label: '姓名',
          prop: 'expertName'
        },
        {
          label: '身份证号',
          prop: 'identificationNumber'
        },
        {
          label: '所在单位',
          prop: 'belongCompanyName'
        },
        {
          label: '专家费（元）',
          prop: 'expertFee'
        },
        {
          label: '手机号码',
          prop: 'mobile'
        },
        this.isByOrderId
          ? undefined
          : {
            label: '认证状态',
            prop: 'authStatus',
            slotName: 'authStatus'
          },
        this.isByOrderId
          ? undefined
          : {
            label: '任务状态',
            prop: 'taskStatus',
            slotName: 'taskStatus'
          },
        this.isByOrderId
          ? undefined
          : {
            label: '支付状态',
            prop: 'payStatus',
            slotName: 'payStatus'
          }
      ].filter(value => value)
    },

    detailOptions() {
      return [
        {
          label: '姓名',
          prop: 'expertName'
        },
        {
          label: '身份证号',
          prop: 'identificationNumber'
        },
        {
          label: '所在单位',
          prop: 'belongCompanyName'
        },
        {
          label: '专家费（元）',
          prop: 'expertFee'
        },
        {
          label: '认证状态',
          prop: 'authStatus',
          filter: value => expertAuthStatusDict.translate(value).label || '-'
        },
        {
          label: '支付状态',
          prop: 'payStatus',
          filter: value => expertFeePayStatusDict.translate(value).label || '-'
        },
        this.expertFeeInfo.payStatus === expertFeePayStatusDict.FAIL.value
          ? {
            label: '失败原因',
            prop: 'payFailReason'
          }
          : undefined
      ].filter(value => value)
    },

    totalExpertFee() {
      return this.expertList
        .reduce((accr, curr) => Number(curr.expertFee) + accr, 0)
        .toFixed(2)
    }
  },

  watch: {
    'requestQuery.order': {
      handler: function(val) {
        this.expertFeeOrderId = val?.expertFeeOrderId
        if (val?.orderName) {
          this.handlePageData(val)
        }
      },
      immediate: true
    },

    'requestQuery.expertFeeOrderId': {
      handler: function(val) {
        this.expertFeeOrderId = val
        if (this.isByOrderId && val) {
          this.getDetail()
        }
      },
      immediate: true
    }
  },

  methods: {
    strToThousands,

    /**
     * 发起打款
     */
    async openPay(row) {
      if (!row.orderNo) return
      await this.$confirm('请确认是否发起打款')
      try {
        await submitExpertFeePayApi(row.orderNo)
        this.$message.success('发起打款成功')
        await this.getDetail()
      } catch (error) {
        this.$message.error(error?.message)
      }
    },

    /**
     * 查看详情
     */
    openDetail(data) {
      this.detailVisible = true
      this.expertFeeInfo = data
    },

    /**
     * 处理页面数据
     */
    handlePageData(data) {
      this.feePayInfo = {
        orderName: data.orderName,
        orderCode: data.orderCode
      }
      this.projectList = data.projectDtoList || []
      this.expertList = data.itemDtoList || []
    },

    /**
     * 查询详情
     */
    async getDetail() {
      try {
        const { data } = await getExpertFeeOrderDetailApi(this.expertFeeOrderId)
        this.handlePageData(data)
      } catch (error) {
        this.$message.error(error?.message)
      }
    }
  }
}
</script>
